export const highlightingAttributesList = ['firstName',
                                        'lastName',
                                        'company',
                                        'streetB',
                                        'cityB',
                                        'zipB',
                                        'crmCountriesB',
                                        'crmUniversityFaculty',
                                        'mobileB',
                                        'phoneB',
                                        'emailB1',
                                        'emailB2',
                                        'facebookB',
                                        'linkedInB',
                                        'twitterB',
                                        'instagramB',
                                        'similarwebB',
                                        'alexaB',
                                        'internetB',
                                        'tradeRegisterNr',
                                        'streetP',
                                        'zipP',
                                        'cityP',
                                        'mobileP',
                                        'phoneP',
                                        'emailP1',
                                        'emailP2',
                                        'facebookP',
                                        'linkedInP',
                                        'twitterP',
                                        'position',
                                        'crmProfiles',
                                        'startupPhaseId',
                                        'crmBranchen',
                                        'crmStartupphases',
                                        'crmAcademicLink',
                                        'crmUniSpinOff',
                                        'crmPrioVlab',
                                        'crmPrioXMas',
                                        'crmCaseStatus',
                                        'crmRechtsformen',
                                        'crmCountriesP',
                                        'crmLanguages',
                                        'crmrducations',
                                        'crmCanton',
                                        'crmBestellungen'
]

export const matchingFieldNames = {
          company: 'Company',
          firstName: 'Firstname',
          lastName: 'Lastname',
          oneLiner_en: 'OneLiner En',
          streetB: 'Street B',
          zipB: 'Zip B',
          cityB: 'City B',
          incorporationDate: 'Incorporation Date',
          description_open_en: 'Description Open EN',
          description_safe_en: 'Description Safe EN',
          mobileB: 'Mobile B',
          phoneB: 'Phone B',
          emailB1: 'Email B1',
          emailB2: 'Email B2',
          facebookB: 'Facebook B',
          linkedInB: 'LinkedIn B',
          twitterB: 'Twitter B',
          instagramB: 'Instagram B',
          similarwebB: 'Similarweb B',
          alexaB: 'Alexa B',
          internetB: 'Internet B',
          tradeRegisterNr: 'Trade Register Nr',
          streetP: 'Street P',
          zipP: 'Zip P',
          cityP: 'City P',
          mobileP: 'Mobile P',
          phoneP: 'Phone P',
          emailP1: 'Email P1',
          emailP2: 'Email P2',
          facebookP: 'Facebook P',
          linkedInP: 'LinkedIn P',
          twitterP: 'Twitter P',
          birthday: 'Birthday',
          position: 'Position',
          kantonEN: 'Canton',
          education: 'Education',
          languageEn: 'Language',
          land: 'Country B / P',
          rechtsform: 'Legal Form',
          university: 'University / Acad. Link / Uni Spin Off',
          casestatus: 'Case Status',
          statusxmas: 'Prio Vlab Xmas',
          status: 'Prio Vlab',
          brancheEn: 'Technology',
          kategorieDE: 'Sectors',
          startupphase: 'Startupphase',
          departementFaculty: 'Faculty',
          enterpreneurial: 'Enterpreneurial',
          vleadersproblemopportunity: 'Profiles (Vleaders Problem Opportunity)',
          vleadersProductservice: 'Profiles (Vleaders Product Service)',
          vleadersTechnologie: 'Profiles (Vleaders Technologie)',
          vleadersTargetcustomers: 'Profiles (Vleaders Target Customers)',
          vleadersMarketcompetition: 'Profiles (Vleaders Market Competition)',
          vleadersTeam: 'Profiles (Vleaders Team)',
          vLeadersAchievements: 'Profiles (Vleaders Achievements)',
          vleadersFinancials: 'Profiles (Vleaders Financials)',
          crmbestellungen: 'Orders (Bestellungen)',
          vL1Currentinternationalizationstatus: 'Orders (Bestellungen)',
          vL2Whatareyourgrowthobjectives: 'Orders (Bestellungen)',
          vL3tangibleresults: 'Orders (Bestellungen)',
          vL4Impactthedevelopmentofyourstartup: 'Orders (Bestellungen)',
          vL5keycontributionstotheventureleaders: 'Orders (Bestellungen)',
          ateHowworkshopcreatevalueforproject: 'Orders (Bestellungen)',
          ateWhichmilestonesyouplannext3to9months: 'Orders (Bestellungen)',
          atiatepEquityhaveraised: 'Orders (Bestellungen)',
          atiatepComment: 'Orders (Bestellungen)',
          saQuestion01: 'Orders (Bestellungen)',
          saQuestion02: 'Orders (Bestellungen)',
          saQuestion03: 'Orders (Bestellungen)',
          saQuestion04: 'Orders (Bestellungen)',
          saQuestion05: 'Orders (Bestellungen)',
          saQuestion06: 'Orders (Bestellungen)',
          intlspinoff: 'Orders (Bestellungen)',
          sixHowmuchequityhaveyouraisedsofarinCHF: 'Orders (Bestellungen)',
          sixWhatisyouraccountingstandard: 'Orders (Bestellungen)',
          sixWhatisyourlatestpaidvaluation: 'Orders (Bestellungen)',
          sixWhyshouldyourcompanyselectedfortheIPO: 'Orders (Bestellungen)',
          sixComment: 'Orders (Bestellungen)',
          spsDescribeyourbusinesscase: 'Orders (Bestellungen)',
          spsWhyshouldyouwin: 'Orders (Bestellungen)',
          subcCoremissioncompany: 'Orders (Bestellungen)',
          subCpropositionofferingcustomers: 'Orders (Bestellungen)',
          subcCurrentcustomerkeyreferences: 'Orders (Bestellungen)',
          subC3Swisscorporatespartners: 'Orders (Bestellungen)',
          subcCoorperationtargeting: 'Orders (Bestellungen)',
          sucImpactyourcompany: 'Orders (Bestellungen)',
          sucExpect025GInfrastructure: 'Orders (Bestellungen)',
          sucIconfirmthesolerightstothetechnology: 'Orders (Bestellungen)',
          sucInterestedinpartneringwithSwisscom: 'Orders (Bestellungen)',
          sucExpectambition01SiliconValley: 'Orders (Bestellungen)',
          whoownsthetechnologyandIPrights: 'Orders (Bestellungen)',
          supportfromotherOrganisations: 'Orders (Bestellungen)',
          whatisyourcurrentinternationalizationstatus1: 'Orders (Bestellungen)',
          whichstepstoprotectyourproducts2: 'Orders (Bestellungen)',
          whatareyourobjectivesinterms3: 'Orders (Bestellungen)',
          whoareyourtargetcustomersinAsia5: 'Orders (Bestellungen)',
          howwouldvleadersChinaimpactyourcompany6: 'Orders (Bestellungen)',
          tangibleresultstoachievewhileinChina73: 'Orders (Bestellungen)',
          yourcommunicationpitchingskills8: 'Orders (Bestellungen)',
          yourkeycontributionsshouldyoubenominated9: 'Orders (Bestellungen)'

}

export const formattedExportFields = [
    '_formatted.company',
    '_formatted.firstName',
    '_formatted.lastName',
    '_formatted.crmProfiles[0].oneLiner_en',
    '_formatted.crmProfiles[0].description_open_en',
    '_formatted.streetB',
    '_formatted.zipB',
    '_formatted.cityB',
    '_formatted.mobileB',
    '_formatted.phoneB',
    '_formatted.emailB1',
    '_formatted.emailB2',
    '_formatted.facebookB',
    '_formatted.linkedInB',
    '_formatted.twitterB',
    '_formatted.instagramB',
    '_formatted.similarwebB',
    '_formatted.alexaB',
    '_formatted.internetB',
    '_formatted.tradeRegisterNr',
    '_formatted.streetP',
    '_formatted.zipP',
    '_formatted.cityP',
    '_formatted.mobileP',
    '_formatted.phoneP',
    '_formatted.emailP1',
    '_formatted.emailP2',
    '_formatted.facebookP',
    '_formatted.linkedInP',
    '_formatted.twitterP',
    '_formatted.position',
    '_formatted.crmProfiles[0].vleadersproblemopportunity',
    '_formatted.crmProfiles[0].vleadersProductservice',
    '_formatted.crmProfiles[0].vleadersTechnologie',
    '_formatted.crmProfiles[0].vleadersTargetcustomers',
    '_formatted.crmProfiles[0].vleadersMarketcompetition',
    '_formatted.crmProfiles[0].vleadersTeam',
    '_formatted.crmProfiles[0].vLeadersAchievements',
    '_formatted.crmProfiles[0].vleadersFinancials'
]
